import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { useSnapshot } from "valtio";
import axios from "axios";
import * as actionTypes from "../../../store/actions/actionTypes";
import {
  getVendorProfile,
  getVendorTestimonials,
} from "../../Common/CommonMethods";
import PageMeta from "../../Common/PageMeta";
import Loader from "../../Common/Loader/";
import Canonical from "../../Common/Canonical";
import NoIndex from "../../Common/NoIndex";
import { getCookie } from "../../Common/CommonMethods";
import { openAPI } from "../../../config";
import { VendorTestimonialsData } from "../../../store/ValtioState";

//Refresh UI
import PremiumTestimonialRefresh from "./TestimonialPremiumRefresh";
import VerifiedTestimonialRefresh from "./TestimonialVerifiedRefresh";

const VendorTestimonial = (props) => {
  const { cookies } = props;
  const VendorTestimonialsDataSnap = useSnapshot(VendorTestimonialsData);
  const [routerKey, setRouterKey] = useState("");
  useEffect(() => {
    let qParams = queryString.parse(props.location.search);
    if (Number(qParams.p) === 1) {
      delete qParams.p;
      props.history.push(
        `${props.location.pathname}?${queryString.stringify(qParams)}`
      );
    }
  }, []);

  useEffect(() => {
    if (!props.vendorCommon.slug) {
      //setting unique id of router
      setRouterKey(props?.location?.key);
      props.resetVendorCommonData();
      props.setSlugInCommonData(props.match.params.id);
      fetchCommonForVendor(props.match.params.id);
    } else if (props.vendorCommon.slug !== props.match.params.id) {
      setRouterKey(props?.location?.key);
      verifySlugChangeAndUpdate(props);
    } else {
      if (!!props.vendorTestimonials?.breadcrumb_links) {
        try {
          let slugInVendorTestimonialRedux =
            props.vendorTestimonials?.breadcrumb_links[3]?.link?.split("/");
          if (
            slugInVendorTestimonialRedux[slugInVendorTestimonialRedux - 1] !==
            props.match.params.id
          ) {
            setRouterKey(props?.location?.key);
            props.setSlugInCommonData(props.match.params.id);
            fetchCommonForVendor(props.match.params.id);
          }
        } catch (errBredCrumbLinkNotFound) {
          //
        }
      } else {
        if (routerKey !== props?.location?.key) {
          fetchCommonForVendor(props.match.params.id);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (VendorTestimonialsDataSnap.shouldFetch) {
      getDataForVendor(
        props.match.params.id,
        props.location.pathname.includes("/all")
      );
    }
    //
  }, [VendorTestimonialsDataSnap.shouldFetch]);

  //props.vendorCommon?.slug, props.match?.params?.id

  const TestimonialTabClick = () => {
    if (props.match.path.includes("/vendor/:id/testimonials")) {
      openAPI.put(
        `${process.env.REACT_APP_API_URL}${props.location.pathname
          .replace("/all$", "")
          .replace("/testimonials", "")}/tab-click-log/q`,
        {},
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": `${getCookie("fc_react_csrfmiddlewaretoken")}`,
          },
        }
      );
    }
  };

  const verifySlugChangeAndUpdate = (props) => {
    props.resetVendorCommonData();
    props.setSlugInCommonData(props.match.params.id);
    fetchCommonForVendor(props.match.params.id);
  };

  const fetchCommonForVendor = (vendorId) => {
    openAPI
      .get(`${process.env.REACT_APP_API_URL}/vendor/${vendorId}/common`, {
        withCredentials: true,
      })
      .then((resp) => {
        if (resp.data.status === 200) {
          props.saveVendorCommonData(resp.data);
          getDataForVendor(vendorId, props.location.pathname.includes("/all"));
        } else if (Number(resp.data.status) === 301) {
          if (resp.data.show_no_results) {
            props.history.push(resp.data.url);
          } else {
            props.history.push(`/vendor/${resp.data.new_slug}/testimonials`);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          props.history.push(`/vendor/${vendorId}/no-match`);
        } else {
          console.log("API error while calling :: fetchCommonForVendor ", err);
        }
      });
  };

  const getDataForVendor = (vendorId, isAll) => {
    axios
      .all([
        getVendorProfile(vendorId),
        getVendorTestimonials(
          vendorId,
          isAll,
          props.location.pathname.includes("/testimonials"),
          props.location.search
        ),
      ])
      .then(
        axios.spread((vendorProfileData, vendorTestimonialsData) => {
          if (!vendorProfileData.data.visitor) {
            props.saveVendorProfileData(vendorProfileData.data);
            props.saveVendorTestimonialsData(vendorTestimonialsData.data);
            TestimonialTabClick();
            if (!!VendorTestimonialsDataSnap.shouldFetch) {
              VendorTestimonialsData.shouldFetch = false;
            }
          }
          if (!!vendorProfileData.data.visitor) {
            if (
              !!vendorProfileData.data.visitor.method.email ||
              !!vendorProfileData.data.visitor.method.linkedin
            ) {
              props.saveVendorProfileData({
                ...vendorProfileData.data,
              });
              props.saveVendorTestimonialsData({
                ...vendorTestimonialsData.data,
                num_unblurred_reviews: -1,
              });
              TestimonialTabClick();
            }
          }
          props.setVendorDataLoadedStatus();
          return null;
        })
      );
  };

  const renderComponent =
    props.vendorCommon.vendor_type === "premium" ||
    props.vendorTestimonials.num_unblurred_reviews === -1 ? (
      <PremiumTestimonialRefresh />
    ) : (
      <VerifiedTestimonialRefresh />
    );

  const getPrerenderStatus = (isDataLoaded, searchParams) => {
    if (props.location.search.includes("NaN")) {
      props.history.push(`${props.location.pathname}`);
    }
    return isDataLoaded ? (
      <Helmet>
        <script type="text/javascript">window.prerenderReady = true</script>
      </Helmet>
    ) : (
      <Helmet>
        <script type="text/javascript">window.prerenderReady = false</script>
      </Helmet>
    );
  };

  const getInPageBreadCrumbSchemaForProfile = (props) => {
    return props.vendorProfile && props.vendorProfile.breadcrumb_ld_schema ? (
      <script type="application/ld+json">
        {props.vendorProfile.breadcrumb_ld_schema}
      </script>
    ) : null;
  };

  return (
    <React.Fragment>
      {getPrerenderStatus(
        props.vendorCommon.isDataLoaded,
        props.location.search
      )}
      {Object.keys(props.vendorTestimonials).length > 0 &&
      props.vendorCommon.isDataLoaded ? (
        <React.Fragment>
          <PageMeta {...props.vendorTestimonials} {...props.vendorCommon} />
          <Canonical />
          {props.vendorTestimonials &&
            props.vendorTestimonials.meta_noindex && <NoIndex />}
          {renderComponent}
          {getInPageBreadCrumbSchemaForProfile(props)}
        </React.Fragment>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorTestimonials: state.vendorTestimonials,
    vendorProfile: state.vendorProfile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveVendorCommonData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_COMMON_DATA, payload: data }),
    saveVendorProfileData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_PROFILE_DATA, payload: data }),
    saveVendorTestimonialsData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_DATA,
        payload: data,
      }),
    saveVendorCaseStudiesData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_CASESTUDIES_DATA,
        payload: data,
      }),
    saveVendorVideoData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_VIDEOS_DATA, payload: data }),
    saveVendorCustomersData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_CUSTOMERS_DATA, payload: data }),
    saveVendorFAQData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_FAQ_DATA, payload: data }),
    setVendorDataLoadedStatus: () =>
      dispatch({
        type: actionTypes.SET_VENDOR_DATA_LOADED_TRUE,
      }),
    setSlugInCommonData: (data) =>
      dispatch({
        type: actionTypes.SET_VENDOR_COMMON_DATA_SLUG,
        payload: data,
      }),
    resetVendorCommonData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_COMMON_DATA,
      }),
  };
};

const vendorTestimonialWithRouter = withRouter(withCookies(VendorTestimonial));

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(vendorTestimonialWithRouter);
